<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-16">
        <h4 class="mt-3 mb-4">E-Commerce Skalierungs-Rechner</h4>

      </div>
    </div>
    <div class="row">
      <div :class="calcValues.goalVisitorsTurnoverIncrease.isResult ? 'col-lg-7' : 'col-16' ">
        <p class="sb-bold">Erfolg ist nur die Summe seiner Teile!</p>
        <p>Berechne hier mögliche Ziele anhand verschiedener Stellschrauben und ermittle dadurch das mögliche Umsatzwachstum.</p>

        <div class="row mt-5">
          <div class="col-xl-8 ">
            <h6>IST-Daten</h6>
            <label class="form-label">Umsatz pro Monat</label>


            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatTurnover" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.turnover.suffix"></span>
            </div>
            

            <label class="form-label">Besucher pro Monat</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatVisitors" @focus="$event.target.select()">
              <span v-if="calcValues.visitors.suffix !== ''" class="input-group-text" v-html="calcValues.visitors.suffix"></span>
            </div>
            
            <label class="form-label">&empty; Warenkorbwert / Bestellwert</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control"  v-model="formatAvgBasket" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.avgBasket.suffix"></span>
            </div>
            
          </div>

          <div class="col-xl-8">
            <h6>Ziele</h6>

            <label class="form-label">Wachstum Besucher</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatGoalVisitors" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.goalVisitorsPercent.suffix"></span>
            </div>

            <label class="form-label">Wachstum Conversion-Rate (CR)</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatGoalCr" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.goalCrPercent.suffix"></span>
            </div>

            <label class="form-label">Wachstum Warenkorbwert / Bestellwert</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatGoalBasket" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.goalBasketPercent.suffix"></span>
            </div>
            

          </div>
        </div>
      </div>
      <div class="col-lg-8 offset-lg-1 mt-3" v-if="calcValues.goalVisitorsTurnoverIncrease.isResult">
        <h5>Ergebnis</h5>
        <table width="100%" cellspacing="2" cellpadding="2" class="kpi-table">
          <tr>
            <th colspan="5" class="main-th pb-2">Ziele / Steigerung</th>
          </tr>
          <tr class="sub-tr">
            <th>&nbsp;</th>
            <th>IST</th>
            <th>Besucherzahlen</th>
            <th>Conversion-Rate</th>
            <th>Bestellwert</th>
          </tr>
          <tr class="sub-content-tr">
            <td>Besucher: </td>
            <td>{{ calcValues.visitors.formatted }}<span v-html="calcValues.visitors.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsVisitors.formatted }}<span v-html="calcValues.goalVisitorsVisitors.suffix"></span></td>
            <td>{{ calcValues.goalCrVisitors.formatted }}<span v-html="calcValues.goalCrVisitors.suffix"></span></td>
            <td>{{ calcValues.goalAvgBasketVisitors.formatted }}<span v-html="calcValues.goalAvgBasketVisitors.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Conversion-Rate: </td>
            <td>{{ calcValues.cr.formatted }}<span v-html="calcValues.cr.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCr.formatted }}<span v-html="calcValues.goalVisitorsCr.suffix"></span></td>
            <td>{{ calcValues.goalCrCr.formatted }}<span v-html="calcValues.goalCrCr.suffix"></span></td>
            <td>{{ calcValues.goalAvgBasketCr.formatted }}<span v-html="calcValues.goalAvgBasketCr.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Bestellungen: </td>
            <td>{{ calcValues.orders.formatted }}<span v-html="calcValues.orders.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsOrders.formatted }}<span v-html="calcValues.goalVisitorsOrders.suffix"></span></td>
            <td>{{ calcValues.goalCrOrders.formatted }}<span v-html="calcValues.goalCrOrders.suffix"></span></td>
            <td>{{ calcValues.goalAvgBasketOrders.formatted }}<span v-html="calcValues.goalAvgBasketOrders.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Bestellwert: </td>
            <td>{{ calcValues.avgBasket.formatted }}<span v-html="calcValues.avgBasket.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsAvgBasket.formatted }}<span v-html="calcValues.goalVisitorsOrders.suffix"></span></td>
            <td>{{ calcValues.goalCrAvgBasket.formatted }}<span v-html="calcValues.goalCrAvgBasket.suffix"></span></td>
            <td>{{ calcValues.goalAvgBasketAvgBasket.formatted }}<span v-html="calcValues.goalAvgBasketAvgBasket.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Wert pro Besucher: </td>
            <td>{{ calcValues.customerValue.formatted }}<span v-html="calcValues.customerValue.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCustomerValue.formatted }}<span v-html="calcValues.goalVisitorsCustomerValue.suffix"></span></td>
            <td>{{ calcValues.goalCrCustomerValue.formatted }}<span v-html="calcValues.goalCrCustomerValue.suffix"></span></td>
            <td>{{ calcValues.goalAvgBasketCustomerValue.formatted }}<span v-html="calcValues.goalAvgBasketCustomerValue.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Umsatz: </td>
            <td>{{ calcValues.turnover.formatted }}<span v-html="calcValues.turnover.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsTurnover.formatted }}<span v-html="calcValues.goalVisitorsTurnover.suffix"></span></td>
            <td>{{ calcValues.goalCrTurnover.formatted }}<span v-html="calcValues.goalCrTurnover.suffix"></span></td>
            <td>{{ calcValues.goalAvgBasketTurnover.formatted }}<span v-html="calcValues.goalAvgBasketTurnover.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Umsatzsteigerung: </td>
            <td>{{ calcValues.turnoverIncrease.formatted }}<span v-html="calcValues.turnoverIncrease.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsTurnoverIncrease.formatted }}<span v-html="calcValues.goalVisitorsTurnoverIncrease.suffix"></span></td>
            <td>{{ calcValues.goalCrTurnoverIncrease.formatted }}<span v-html="calcValues.goalCrTurnoverIncrease.suffix"></span></td>
            <td>{{ calcValues.goalAvgBasketTurnoverIncrease.formatted }}<span v-html="calcValues.goalAvgBasketTurnoverIncrease.suffix"></span></td>
          </tr>
          </table>

          <table width="100%" cellspacing="2" cellpadding="2" class="mt-4 kpi-table">
            <tr>
              <th colspan="5" class="main-th pb-2">Ziele / Steigerung mit Kombinationen</th>
            </tr>
            <tr class="sub-tr">
              <th>&nbsp;</th>
              <th>IST</th>
              <th>Besucherzahlen<br/>+ Conversion-Rate</th>
              <th>Besucherzahlen<br/>+ Bestellwert</th>
              <th>Conversion-Rate<br/>+ Bestellwert</th>
            </tr>
            <tr class="sub-content-tr">
              <td>Besucher: </td>
              <td>{{ calcValues.visitors.formatted }}<span v-html="calcValues.visitors.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsCrVisitors.formatted }}<span v-html="calcValues.goalVisitorsCrVisitors.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsAvgBasketVisitors.formatted }}<span v-html="calcValues.goalVisitorsAvgBasketVisitors.suffix"></span></td>
              <td>{{ calcValues.goalCrAvgBasketVisitors.formatted }}<span v-html="calcValues.goalCrAvgBasketVisitors.suffix"></span></td>
            </tr>
            <tr class="sub-content-tr">
              <td>Conversion-Rate: </td>
              <td>{{ calcValues.cr.formatted }}<span v-html="calcValues.cr.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsCrCr.formatted }}<span v-html="calcValues.goalVisitorsCrCr.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsAvgBasketCr.formatted }}<span v-html="calcValues.goalVisitorsAvgBasketCr.suffix"></span></td>
              <td>{{ calcValues.goalCrAvgBasketCr.formatted }}<span v-html="calcValues.goalCrAvgBasketCr.suffix"></span></td>
            </tr>
            <tr class="sub-content-tr">
              <td>Bestellungen: </td>
              <td>{{ calcValues.orders.formatted }}<span v-html="calcValues.orders.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsCrOrders.formatted }}<span v-html="calcValues.goalVisitorsCrOrders.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsAvgBasketOrders.formatted }}<span v-html="calcValues.goalVisitorsAvgBasketOrders.suffix"></span></td>
              <td>{{ calcValues.goalCrAvgBasketOrders.formatted }}<span v-html="calcValues.goalCrAvgBasketOrders.suffix"></span></td>
            </tr>
            <tr class="sub-content-tr">
              <td>Bestellwert: </td>
              <td>{{ calcValues.avgBasket.formatted }}<span v-html="calcValues.avgBasket.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsCrAvgBasket.formatted }}<span v-html="calcValues.goalVisitorsCrAvgBasket.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsAvgBasketAvgBasket.formatted }}<span v-html="calcValues.goalVisitorsAvgBasketAvgBasket.suffix"></span></td>
              <td>{{ calcValues.goalCrAvgBasketAvgBasket.formatted }}<span v-html="calcValues.goalCrAvgBasketAvgBasket.suffix"></span></td>
            </tr>
            <tr class="sub-content-tr">
              <td>Wert pro Besucher: </td>
              <td>{{ calcValues.customerValue.formatted }}<span v-html="calcValues.customerValue.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsCrCustomerValue.formatted }}<span v-html="calcValues.goalVisitorsCrCustomerValue.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsAvgBasketCustomerValue.formatted }}<span v-html="calcValues.goalVisitorsAvgBasketCustomerValue.suffix"></span></td>
              <td>{{ calcValues.goalCrAvgBasketCustomerValue.formatted }}<span v-html="calcValues.goalCrAvgBasketCustomerValue.suffix"></span></td>
            </tr>
            <tr class="sub-content-tr">
              <td>Umsatz: </td>
              <td>{{ calcValues.turnover.formatted }}<span v-html="calcValues.turnover.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsCrTurnover.formatted }}<span v-html="calcValues.goalVisitorsCrTurnover.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsAvgBasketTurnover.formatted }}<span v-html="calcValues.goalVisitorsAvgBasketTurnover.suffix"></span></td>
              <td>{{ calcValues.goalCrAvgBasketTurnover.formatted }}<span v-html="calcValues.goalCrAvgBasketTurnover.suffix"></span></td>
            </tr>
            <tr class="sub-content-tr">
              <td>Umsatzsteigerung: </td>
              <td>{{ calcValues.turnoverIncrease.formatted }}<span v-html="calcValues.turnoverIncrease.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsCrTurnoverIncrease.formatted }}<span v-html="calcValues.goalVisitorsCrTurnoverIncrease.suffix"></span></td>
              <td>{{ calcValues.goalVisitorsAvgBasketTurnoverIncrease.formatted }}<span v-html="calcValues.goalVisitorsAvgBasketTurnoverIncrease.suffix"></span></td>
              <td>{{ calcValues.goalCrAvgBasketTurnoverIncrease.formatted }}<span v-html="calcValues.goalCrAvgBasketTurnoverIncrease.suffix"></span></td>
            </tr>
          </table>

          <table width="100%" cellspacing="2" cellpadding="2" class="mt-4 kpi-table" >
          <tr>
        
            <th colspan="3" class="main-th pb-2">Ziele / Steigerung mit allen Kombinationen</th>
          </tr>
          <tr class="sub-tr">
            <th>&nbsp;</th>
            <th>IST</th>
            <th>Besucherzahlen + Conversion-Rate + Bestellwert</th>
          </tr>
          <tr class="sub-content-tr">
            <td>Besucher: </td>
            <td>{{ calcValues.visitors.formatted }}<span v-html="calcValues.visitors.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCrAvgBasketVisitors.formatted }}<span v-html="calcValues.goalVisitorsCrAvgBasketVisitors.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Conversion-Rate: </td>
            <td>{{ calcValues.cr.formatted }}<span v-html="calcValues.cr.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCrAvgBasketCr.formatted }}<span v-html="calcValues.goalVisitorsCrAvgBasketCr.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Bestellungen: </td>
            <td>{{ calcValues.orders.formatted }}<span v-html="calcValues.orders.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCrAvgBasketOrders.formatted }}<span v-html="calcValues.goalVisitorsCrAvgBasketOrders.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Bestellwert: </td>
            <td>{{ calcValues.avgBasket.formatted }}<span v-html="calcValues.avgBasket.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCrAvgBasketAvgBasket.formatted }}<span v-html="calcValues.goalVisitorsCrAvgBasketAvgBasket.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Wert pro Besucher: </td>
            <td>{{ calcValues.customerValue.formatted }}<span v-html="calcValues.customerValue.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCrAvgBasketCustomerValue.formatted }}<span v-html="calcValues.goalVisitorsCrAvgBasketCustomerValue.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Umsatz: </td>
            <td>{{ calcValues.turnover.formatted }}<span v-html="calcValues.turnover.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCrAvgBasketTurnover.formatted }}<span v-html="calcValues.goalVisitorsCrAvgBasketTurnover.suffix"></span></td>
          </tr>
          <tr class="sub-content-tr">
            <td>Umsatzsteigerung: </td>
            <td>{{ calcValues.turnoverIncrease.formatted }}<span v-html="calcValues.turnoverIncrease.suffix"></span></td>
            <td>{{ calcValues.goalVisitorsCrAvgBasketTurnoverIncrease.formatted }}<span v-html="calcValues.goalVisitorsCrAvgBasketTurnoverIncrease.suffix"></span></td>
          </tr>

        </table>
      </div>
    </div>
    <div class="row  mt-3">
      <div class="col-16" v-if="calcValues.goalVisitorsTurnoverIncrease.isResult">
        <div class="row">
          <div class="col-lg">
            <apex-chart width="100%" height="400" :options="chartoptions1" :series="getChartData1"></apex-chart>
          </div>

          <div class="col-lg">
            <apex-chart width="100%" height="400" :options="chartoptions2" :series="getChartData2"></apex-chart>
          </div>
          <div class="col-lg">
            <apex-chart width="100%" height="400" :options="chartoptions3" :series="getChartData3"></apex-chart>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-16 mt-3" v-if="calcValues.goalVisitorsTurnoverIncrease.isResult">
        <div class="row">
          <div class="col-lg">
            <apex-chart width="100%" height="400" :options="chartoptions4" :series="getChartData4"></apex-chart>
          </div>

          <div class="col-lg">
            <apex-chart width="100%" height="400" :options="chartoptions5" :series="getChartData5"></apex-chart>
          </div>
         
        </div>
      </div>
    </div>
 </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "scaleGoals",
  components: {
    'apexChart': VueApexCharts,
  },
  data() {
    return {
      chartoptions1: {},
      chartoptions2: {},
      chartoptions3: {},
      chartoptions4: {},
      chartoptions5: {},
      calcValues: {

        goalCrPercent: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalVisitorsPercent: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalBasketPercent: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },

        //IST

        turnover: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        visitors: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        avgBasket: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        cr: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        orders: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        customerValue: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        turnoverIncrease: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },

        //SOLL Visitor

        goalVisitorsTurnover: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsVisitors: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalVisitorsAvgBasket: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsCr: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalVisitorsOrders: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalVisitorsCustomerValue: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsTurnoverIncrease: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },

        //SOLL CR

        goalCrTurnover: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalCrVisitors: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalCrAvgBasket: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalCrCr: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalCrOrders: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalCrCustomerValue: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalCrTurnoverIncrease: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },

        //SOLL avgBasket

        goalAvgBasketTurnover: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalAvgBasketVisitors: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalAvgBasketAvgBasket: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalAvgBasketCr: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalAvgBasketOrders: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalAvgBasketCustomerValue: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalAvgBasketTurnoverIncrease: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },


        //SOLL goalVisitorsCr

        goalVisitorsCrTurnover: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsCrVisitors: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalVisitorsCrAvgBasket: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsCrCr: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalVisitorsCrOrders: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalVisitorsCrCustomerValue: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsCrTurnoverIncrease: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },


        //SOLL goalVisitorsAvgBasket

        goalVisitorsAvgBasketTurnover: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsAvgBasketVisitors: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalVisitorsAvgBasketAvgBasket: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsAvgBasketCr: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalVisitorsAvgBasketOrders: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalVisitorsAvgBasketCustomerValue: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsAvgBasketTurnoverIncrease: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },


        //SOLL goalCrAvgBasket

        goalCrAvgBasketTurnover: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalCrAvgBasketVisitors: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalCrAvgBasketAvgBasket: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalCrAvgBasketCr: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalCrAvgBasketOrders: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalCrAvgBasketCustomerValue: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalCrAvgBasketTurnoverIncrease: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },


        //SOLL goalVisitorsCrAvgBasket

        goalVisitorsCrAvgBasketTurnover: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsCrAvgBasketVisitors: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalVisitorsCrAvgBasketAvgBasket: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsCrAvgBasketCr: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        goalVisitorsCrAvgBasketOrders: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        goalVisitorsCrAvgBasketCustomerValue: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        goalVisitorsCrAvgBasketTurnoverIncrease: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        



      }

    }
  },
  mounted() {
  

  this.chartoptions1 = {...this.$chartconfig.chartOptionsColumn, ...{
    colors: ['#52388E', '#AD0267'],
    xaxis: {
        categories: ['Besucherzahlen'],
    },
    tooltip: {
        y: {
            formatter: function (val) {
                return val
            }
        }
      },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
       },
       offsetY: -20,
       style: {
          colors: ["#250719"]
      }
    }
  }},

  this.chartoptions2 = {...this.$chartconfig.chartOptionsColumn, ...{
    colors: ['#52388E', '#AD0267'],
    xaxis: {
        categories: ['Conversion-Rate'],
    },
    tooltip: {
        y: {
          formatter:  (val) => {
            return `${this.$utils.beautifier(val)} %`;
          }
        }
      },
    dataLabels: {
      enabled: true,
      formatter:  (val) => {
        return `${this.$utils.beautifier(val)} %`;
       },
       offsetY: -20,
       style: {
          colors: ["#250719"]
      }
    }
  }},
  this.chartoptions3 = {...this.$chartconfig.chartOptionsColumn, ...{
    colors: ['#52388E', '#AD0267'],
    xaxis: {
        categories: ['Bestellwert'],
    },
    tooltip: {
        y: {
          formatter:  (val) => {
            return `${this.$utils.beautifier(val)} €`;
          },
        }
    },
    dataLabels: {
      enabled: true,
      formatter:  (val) => {
        return `${this.$utils.beautifier(val)} €`;
       },
       offsetY: -20,
       style: {
          colors: ["#250719"]
      }
    }
  }},
  this.chartoptions4 = {...this.$chartconfig.chartOptionsColumn, ...{
    colors:  ['#52388E', '#AD0267', '#A28AD9', '#250719', '#F51760',  '#707070', '#BFBFBF'],
    xaxis: {
        categories: ['Umsatz'],
    },
    tooltip: {
        y: {
          formatter:  (val) => {
            return `${this.$utils.beautifier(val)} €`;
          },
        }
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: '100%',
            endingShape: 'rounded',
            borderRadius: 3,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
        },
    },   
    dataLabels: {
      enabled: true,
      formatter:  (val) => {
        return `${this.$utils.beautifier(val)} €`;
       },
       offsetY: -20,
       style: {
          colors: ["#250719"]
      }
    }
  }},
  this.chartoptions5 = {...this.$chartconfig.chartOptionsColumn, ...{
    colors:  ['#52388E', '#AD0267', '#A28AD9', '#250719', '#F51760',  '#707070', '#BFBFBF'],
    xaxis: {
        categories: ['Umsatzsteigerung'],
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: '100%',
            endingShape: 'rounded',
            borderRadius: 3,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
        },
    },   
    tooltip: {
        y: {
          formatter:  (val) => {
            return `${this.$utils.beautifier(val)} %`;
          },
        }
    },
    dataLabels: {
      enabled: true,
      formatter:  (val) => {
        return `${this.$utils.beautifier(val)} %`;
       },
       offsetY: -20,
       style: {
          colors: ["#250719"]
      }
    }
  }}
  
},
  computed: {
    formatVisitors: {
      get () {
        return this.getObj('visitors').number;
      },
      set (value) {
        return this.setObj('visitors', value, 1);
      }
    },
    formatAvgBasket: {
      get () {
        return this.getObj('avgBasket').number;
      },
      set (value) {
        return this.setObj('avgBasket', value, 1);
      }
    },
    formatTurnover: {
      get () {
        return this.getObj('turnover').number;
      },
      set (value) {
        return this.setObj('turnover', value, 1);
      }
    },
    formatAvgCpc: {
      get () {
        return this.getObj('avgCpc').number;
      },
      set (value) {
        return this.setObj('avgCpc', value, 1);
      }
    },
    formatGoalCr: {
      get () {
        return this.getObj('goalCrPercent').number;
      },
      set (value) {
        return this.setObj('goalCrPercent', value, 1);
      }
    },
    formatGoalVisitors: {
      get () {
        return this.getObj('goalVisitorsPercent').number;
      },
      set (value) {
        return this.setObj('goalVisitorsPercent', value, 1);
      }
    },
    formatGoalBasket: {
      get () {
        return this.getObj('goalBasketPercent').number;
      },
      set (value) {
        return this.setObj('goalBasketPercent', value, 1);
      }
    },
    getChartData1 () {
      return [{
          name: 'IST',
          data: [this.calcValues.visitors.number]
        },
        {
          name: 'Besucher + x%',
          data: [this.calcValues.goalVisitorsVisitors.number]
        }]
    },
    getChartData2 () {
      return [{
          name: 'IST',
          data: [this.calcValues.cr.number]
        },
        {
          name: 'Conversion-Rate + x%',
          data: [this.calcValues.goalCrCr.number]
        }]
    },
    getChartData3 () {
      return [{
          name: 'IST',
          data: [this.calcValues.avgBasket.number]
        },
        {
          name: 'Bestellwert + x%',
          data: [this.calcValues.goalAvgBasketAvgBasket.number]
        }]
    },
    getChartData4 () {
      return [{
          name: 'Besucherzahlen + x%',
          data: [this.calcValues.goalVisitorsTurnover.number]
        },
        {
          name: 'Conversion-Rate + x%',
          data: [ this.calcValues.goalCrTurnover.number]
        },
        {
          name: 'Bestellwert + x%',
          data: [ this.calcValues.goalAvgBasketTurnover.number]
        },
        {
          name: 'Besucherzahlen + Conversion-Rate',
          data: [this.calcValues.goalVisitorsCrTurnover.number]
        },
        {
          name: 'Besucherzahlen + Bestellwert',
          data: [ this.calcValues.goalVisitorsAvgBasketTurnover.number]
        },
        {
          name: 'Conversion-Rate + Bestellwert',
          data: [ this.calcValues.goalCrAvgBasketTurnover.number]
        },
        {
          name: 'Besucherzahlen + Conversion-Rate + Bestellwert',
          data: [ this.calcValues.goalVisitorsCrAvgBasketTurnover.number]
        }]
    },
    getChartData5 () {
      return [{
          name: 'Besucherzahlen + x%',
          data: [this.calcValues.goalVisitorsCrTurnoverIncrease.number]
        },
        {
          name: 'Conversion-Rate + x%',
          data: [ this.calcValues.goalCrTurnoverIncrease.number]
        },
        {
          name: 'Bestellwert + x%',
          data: [ this.calcValues.goalAvgBasketTurnoverIncrease.number]
        },
        {
          name: 'Besucherzahlen + Conversion-Rate',
          data: [this.calcValues.goalVisitorsCrTurnoverIncrease.number]
        },
        {
          name: 'Besucherzahlen + Bestellwert',
          data: [ this.calcValues.goalVisitorsAvgBasketTurnoverIncrease.number]
        },
        {
          name: 'Conversion-Rate + Bestellwert',
          data: [ this.calcValues.goalCrAvgBasketTurnoverIncrease.number]
        },
        {
          name: 'Besucherzahlen + Conversion-Rate + Bestellwert',
          data: [ this.calcValues.goalVisitorsCrAvgBasketTurnoverIncrease.number]
        }]
    }
  },
  methods: {
    
    setObj(name, value, calcResult) {
      let obj = this.getObj(name);
      obj.number = this.$utils.formatStr2Number(value);
      var digits = 2;
      if ('formatDigits' in obj) {
        digits = obj.formatDigits;
      }
      obj.formatted = this.$utils.beautifier(obj.number, 'de-DE', digits);
      //console.log(obj.number, obj.formatted);
      this.calcValues[name] = obj;

      if (calcResult) this.calcResult();

      return obj.number;
    },
    setObjContent(name, obj, calcResult) {
      this.calcValues[name] = obj;
      this.setObj(name, obj.number, calcResult);
    },
    getObj(name) {
      return this.calcValues[name];
    },
    calcResult() {

      let goalCrPercent = this.calcValues.goalCrPercent;
      let goalVisitorsPercent = this.calcValues.goalVisitorsPercent;
      let goalBasketPercent = this.calcValues.goalBasketPercent;

      let turnover = this.calcValues.turnover;
      let visitors = this.calcValues.visitors;
      let avgBasket = this.calcValues.avgBasket;
      let cr = this.calcValues.cr;
      let orders = this.calcValues.orders;
      let customerValue = this.calcValues.customerValue;

      let goalVisitorsTurnover = this.calcValues.goalVisitorsTurnover;
      let goalVisitorsVisitors = this.calcValues.goalVisitorsVisitors;
      let goalVisitorsAvgBasket = this.calcValues.goalVisitorsAvgBasket;
      let goalVisitorsCr = this.calcValues.goalVisitorsCr;
      let goalVisitorsOrders = this.calcValues.goalVisitorsOrders;
      let goalVisitorsCustomerValue = this.calcValues.goalVisitorsCustomerValue;
      let goalVisitorsTurnoverIncrease = this.calcValues.goalVisitorsTurnoverIncrease;

      let goalCrTurnover = this.calcValues.goalCrTurnover;
      let goalCrVisitors = this.calcValues.goalCrVisitors;
      let goalCrAvgBasket = this.calcValues.goalCrAvgBasket;
      let goalCrCr = this.calcValues.goalCrCr;
      let goalCrOrders = this.calcValues.goalCrOrders;
      let goalCrCustomerValue = this.calcValues.goalCrCustomerValue;
      let goalCrTurnoverIncrease = this.calcValues.goalCrTurnoverIncrease;

      let goalAvgBasketTurnover = this.calcValues.goalAvgBasketTurnover;
      let goalAvgBasketVisitors = this.calcValues.goalAvgBasketVisitors;
      let goalAvgBasketAvgBasket = this.calcValues.goalAvgBasketAvgBasket;
      let goalAvgBasketCr = this.calcValues.goalAvgBasketCr;
      let goalAvgBasketOrders = this.calcValues.goalAvgBasketOrders;
      let goalAvgBasketCustomerValue = this.calcValues.goalAvgBasketCustomerValue;
      let goalAvgBasketTurnoverIncrease = this.calcValues.goalAvgBasketTurnoverIncrease;

      let goalVisitorsCrTurnover = this.calcValues.goalVisitorsCrTurnover;
      let goalVisitorsCrVisitors = this.calcValues.goalVisitorsCrVisitors;
      let goalVisitorsCrAvgBasket = this.calcValues.goalVisitorsCrAvgBasket;
      let goalVisitorsCrCr = this.calcValues.goalVisitorsCrCr;
      let goalVisitorsCrOrders = this.calcValues.goalVisitorsCrOrders;
      let goalVisitorsCrCustomerValue = this.calcValues.goalVisitorsCrCustomerValue;
      let goalVisitorsCrTurnoverIncrease = this.calcValues.goalVisitorsCrTurnoverIncrease;

      let goalVisitorsAvgBasketTurnover = this.calcValues.goalVisitorsAvgBasketTurnover;
      let goalVisitorsAvgBasketVisitors = this.calcValues.goalVisitorsAvgBasketVisitors;
      let goalVisitorsAvgBasketAvgBasket = this.calcValues.goalVisitorsAvgBasketAvgBasket;
      let goalVisitorsAvgBasketCr = this.calcValues.goalVisitorsAvgBasketCr;
      let goalVisitorsAvgBasketOrders = this.calcValues.goalVisitorsAvgBasketOrders;
      let goalVisitorsAvgBasketCustomerValue = this.calcValues.goalVisitorsAvgBasketCustomerValue;
      let goalVisitorsAvgBasketTurnoverIncrease = this.calcValues.goalVisitorsAvgBasketTurnoverIncrease;

      let goalCrAvgBasketTurnover = this.calcValues.goalCrAvgBasketTurnover;
      let goalCrAvgBasketVisitors = this.calcValues.goalCrAvgBasketVisitors;
      let goalCrAvgBasketAvgBasket = this.calcValues.goalCrAvgBasketAvgBasket;
      let goalCrAvgBasketCr = this.calcValues.goalCrAvgBasketCr;
      let goalCrAvgBasketOrders = this.calcValues.goalCrAvgBasketOrders;
      let goalCrAvgBasketCustomerValue = this.calcValues.goalCrAvgBasketCustomerValue;
      let goalCrAvgBasketTurnoverIncrease = this.calcValues.goalCrAvgBasketTurnoverIncrease;
      
      let goalVisitorsCrAvgBasketTurnover = this.calcValues.goalVisitorsCrAvgBasketTurnover;
      let goalVisitorsCrAvgBasketVisitors = this.calcValues.goalVisitorsCrAvgBasketVisitors;
      let goalVisitorsCrAvgBasketAvgBasket = this.calcValues.goalVisitorsCrAvgBasketAvgBasket;
      let goalVisitorsCrAvgBasketCr = this.calcValues.goalVisitorsCrAvgBasketCr;
      let goalVisitorsCrAvgBasketOrders = this.calcValues.goalVisitorsCrAvgBasketOrders;
      let goalVisitorsCrAvgBasketCustomerValue = this.calcValues.goalVisitorsCrAvgBasketCustomerValue;
      let goalVisitorsCrAvgBasketTurnoverIncrease = this.calcValues.goalVisitorsCrAvgBasketTurnoverIncrease;

      //IST-Bestellungen
      if (avgBasket.number > 0) {
        orders.number = Math.floor(turnover.number / avgBasket.number);
        this.setObj('orders',  orders.number, 0);
      }

      //CR
      cr.number = orders.number / (visitors.number / 100);
      this.setObj('cr',  cr.number, 0);

      //customerValue
      if (visitors.number > 0) {
        customerValue.number = turnover.number / visitors.number;
        this.setObj('customerValue',  customerValue.number, 0);
      }

      //goalVisitors

      //goalVisitorsVisitors
      goalVisitorsVisitors.number = Math.floor((visitors.number / 100 * goalVisitorsPercent.number) + visitors.number);
      this.setObj('goalVisitorsVisitors',  goalVisitorsVisitors.number, 0);

      //goalVisitorsAvgBasket
      goalVisitorsAvgBasket.number = avgBasket.number;
      this.setObj('goalVisitorsAvgBasket',  goalVisitorsAvgBasket.number, 0);

      //goalVisitorsCr
      goalVisitorsCr.number = cr.number;
      this.setObj('goalVisitorsCr',  goalVisitorsCr.number, 0);

      //goalVisitorsOrders
      goalVisitorsOrders.number = Math.floor(goalVisitorsVisitors.number * goalVisitorsCr.number / 100);
      this.setObj('goalVisitorsOrders',  goalVisitorsOrders.number, 0);

      //goalVisitorsTurnover
      goalVisitorsTurnover.number = goalVisitorsOrders.number * goalVisitorsAvgBasket.number;
      this.setObj('goalVisitorsTurnover',  goalVisitorsTurnover.number, 0);

      //goalVisitorsTurnover
      if (goalVisitorsVisitors.number > 0) {
        goalVisitorsCustomerValue.number = goalVisitorsTurnover.number / goalVisitorsVisitors.number;
        this.setObj('goalVisitorsCustomerValue', goalVisitorsCustomerValue.number, 0);
      }

      //goalVisitorsTurnoverIncrease
      goalVisitorsTurnoverIncrease.number = (goalVisitorsTurnover.number - turnover.number) / turnover.number * 100;
      goalVisitorsTurnoverIncrease.isResult = true;
      this.setObjContent('goalVisitorsTurnoverIncrease', goalVisitorsTurnoverIncrease, 0);


      //goalCr

      //goalCrVisitors
      goalCrVisitors.number = visitors.number;
      this.setObj('goalCrVisitors',  goalCrVisitors.number, 0);

      //goalCrAvgBasket
      goalCrAvgBasket.number = avgBasket.number;
      this.setObj('goalCrAvgBasket',  goalCrAvgBasket.number, 0);

      //goalCrCr
      goalCrCr.number = (cr.number / 100 * goalCrPercent.number) + cr.number;
      this.setObj('goalCrCr',  goalCrCr.number, 0);

      //goalCrOrders
      goalCrOrders.number = Math.floor(goalCrVisitors.number * goalCrCr.number / 100);
      this.setObj('goalCrOrders',  goalCrOrders.number, 0);

      //goalCrTurnover
      goalCrTurnover.number = goalCrOrders.number * goalCrAvgBasket.number;
      this.setObj('goalCrTurnover',  goalCrTurnover.number, 0);

      //goalCrTurnover
      if (goalCrVisitors.number > 0) {
        goalCrCustomerValue.number = goalCrTurnover.number / goalCrVisitors.number;
        this.setObj('goalCrCustomerValue', goalCrCustomerValue.number, 0);
      }

      //goalCrTurnoverIncrease
      goalCrTurnoverIncrease.number = (goalCrTurnover.number - turnover.number) / turnover.number * 100;
      goalCrTurnoverIncrease.isResult = true;
      this.setObjContent('goalCrTurnoverIncrease', goalCrTurnoverIncrease, 0);


      //goalAvgBasket

      //goalAvgBasketVisitors
      goalAvgBasketVisitors.number = visitors.number;
      this.setObj('goalAvgBasketVisitors',  goalAvgBasketVisitors.number, 0);

      //goalAvgBasketAvgBasket
      goalAvgBasketAvgBasket.number = (avgBasket.number / 100 * goalBasketPercent.number) + avgBasket.number;
      this.setObj('goalAvgBasketAvgBasket',  goalAvgBasketAvgBasket.number, 0);

      //goalAvgBasketCr
      goalAvgBasketCr.number = cr.number;
      this.setObj('goalAvgBasketCr',  goalAvgBasketCr.number, 0);

      //goalAvgBasketOrders
      goalAvgBasketOrders.number = Math.floor(goalAvgBasketVisitors.number * goalAvgBasketCr.number / 100);
      this.setObj('goalAvgBasketOrders',  goalAvgBasketOrders.number, 0);

      //goalAvgBasketTurnover
      goalAvgBasketTurnover.number = goalAvgBasketOrders.number * goalAvgBasketAvgBasket.number;
      this.setObj('goalAvgBasketTurnover',  goalAvgBasketTurnover.number, 0);

      //goalAvgBasketTurnover
      if (goalAvgBasketVisitors.number > 0) {
        goalAvgBasketCustomerValue.number = goalAvgBasketTurnover.number / goalAvgBasketVisitors.number;
        this.setObj('goalAvgBasketCustomerValue', goalAvgBasketCustomerValue.number, 0);
      }

      //goalAvgBasketTurnoverIncrease
      goalAvgBasketTurnoverIncrease.number = (goalAvgBasketTurnover.number - turnover.number) / turnover.number * 100;
      goalAvgBasketTurnoverIncrease.isResult = true;
      this.setObjContent('goalAvgBasketTurnoverIncrease', goalAvgBasketTurnoverIncrease, 0);


      //goalVisitorsCr

      //goalVisitorsCrVisitors
      goalVisitorsCrVisitors.number = goalVisitorsVisitors.number;
      this.setObj('goalVisitorsCrVisitors',  goalVisitorsCrVisitors.number, 0);

      //goalVisitorsCrAvgBasket
      goalVisitorsCrAvgBasket.number = avgBasket.number;
      this.setObj('goalVisitorsCrAvgBasket',  goalVisitorsCrAvgBasket.number, 0);

      //goalVisitorsCrCr
      goalVisitorsCrCr.number = goalCrCr.number;
      this.setObj('goalVisitorsCrCr',  goalVisitorsCrCr.number, 0);

      //goalVisitorsCrOrders
      goalVisitorsCrOrders.number = Math.floor(goalVisitorsCrVisitors.number * goalVisitorsCrCr.number / 100);
      this.setObj('goalVisitorsCrOrders',  goalVisitorsCrOrders.number, 0);

      //goalVisitorsCrTurnover
      goalVisitorsCrTurnover.number = goalVisitorsCrOrders.number * goalVisitorsCrAvgBasket.number;
      this.setObj('goalVisitorsCrTurnover',  goalVisitorsCrTurnover.number, 0);

      //goalVisitorsCrTurnover
      if (goalVisitorsCrVisitors.number > 0) {
        goalVisitorsCrCustomerValue.number = goalVisitorsCrTurnover.number / goalVisitorsCrVisitors.number;
        this.setObj('goalVisitorsCrCustomerValue', goalVisitorsCrCustomerValue.number, 0);
      }

      //goalVisitorsCrTurnoverIncrease
      goalVisitorsCrTurnoverIncrease.number = (goalVisitorsCrTurnover.number - turnover.number) / turnover.number * 100;
      goalVisitorsCrTurnoverIncrease.isResult = true;
      this.setObjContent('goalVisitorsCrTurnoverIncrease', goalVisitorsCrTurnoverIncrease, 0);


      //goalVisitorsAvgBasket

      //goalVisitorsAvgBasketVisitors
      goalVisitorsAvgBasketVisitors.number = goalVisitorsVisitors.number;
      this.setObj('goalVisitorsAvgBasketVisitors',  goalVisitorsAvgBasketVisitors.number, 0);

      //goalVisitorsAvgBasketAvgBasket
      goalVisitorsAvgBasketAvgBasket.number = goalAvgBasketAvgBasket.number;
      this.setObj('goalVisitorsAvgBasketAvgBasket',  goalVisitorsAvgBasketAvgBasket.number, 0);

      //goalVisitorsAvgBasketCr
      goalVisitorsAvgBasketCr.number = goalVisitorsCr.number;
      this.setObj('goalVisitorsAvgBasketCr',  goalVisitorsAvgBasketCr.number, 0);

      //goalVisitorsAvgBasketOrders
      goalVisitorsAvgBasketOrders.number = Math.floor(goalVisitorsAvgBasketVisitors.number * goalVisitorsAvgBasketCr.number / 100);
      this.setObj('goalVisitorsAvgBasketOrders',  goalVisitorsAvgBasketOrders.number, 0);

      //goalVisitorsAvgBasketTurnover
      goalVisitorsAvgBasketTurnover.number = goalVisitorsAvgBasketOrders.number * goalVisitorsAvgBasketAvgBasket.number;
      this.setObj('goalVisitorsAvgBasketTurnover',  goalVisitorsAvgBasketTurnover.number, 0);

      //goalVisitorsAvgBasketTurnover
      if (goalVisitorsAvgBasketVisitors.number > 0) {
        goalVisitorsAvgBasketCustomerValue.number = goalVisitorsAvgBasketTurnover.number / goalVisitorsAvgBasketVisitors.number;
        this.setObj('goalVisitorsAvgBasketCustomerValue', goalVisitorsAvgBasketCustomerValue.number, 0);
      }

      //goalVisitorsAvgBasketTurnoverIncrease
      goalVisitorsAvgBasketTurnoverIncrease.number = (goalVisitorsAvgBasketTurnover.number - turnover.number) / turnover.number * 100;
      goalVisitorsAvgBasketTurnoverIncrease.isResult = true;
      this.setObjContent('goalVisitorsAvgBasketTurnoverIncrease', goalVisitorsAvgBasketTurnoverIncrease, 0);


      //goalCrAvgBasket

      //goalCrAvgBasketVisitors
      goalCrAvgBasketVisitors.number = goalCrVisitors.number;
      this.setObj('goalCrAvgBasketVisitors',  goalCrAvgBasketVisitors.number, 0);

      //goalCrAvgBasketAvgBasket
      goalCrAvgBasketAvgBasket.number = goalAvgBasketAvgBasket.number;
      this.setObj('goalCrAvgBasketAvgBasket',  goalCrAvgBasketAvgBasket.number, 0);

      //goalCrAvgBasketCr
      goalCrAvgBasketCr.number = goalCrCr.number;
      this.setObj('goalCrAvgBasketCr',  goalCrAvgBasketCr.number, 0);

      //goalCrAvgBasketOrders
      goalCrAvgBasketOrders.number = Math.floor(goalCrAvgBasketVisitors.number * goalCrAvgBasketCr.number / 100);
      this.setObj('goalCrAvgBasketOrders',  goalCrAvgBasketOrders.number, 0);

      //goalCrAvgBasketTurnover
      goalCrAvgBasketTurnover.number = goalCrAvgBasketOrders.number * goalCrAvgBasketAvgBasket.number;
      this.setObj('goalCrAvgBasketTurnover',  goalCrAvgBasketTurnover.number, 0);

      //goalCrAvgBasketTurnover
      if (goalCrAvgBasketVisitors.number > 0) {
        goalCrAvgBasketCustomerValue.number = goalCrAvgBasketTurnover.number / goalCrAvgBasketVisitors.number;
        this.setObj('goalCrAvgBasketCustomerValue', goalCrAvgBasketCustomerValue.number, 0);
      }

      //goalCrAvgBasketTurnoverIncrease
      goalCrAvgBasketTurnoverIncrease.number = (goalCrAvgBasketTurnover.number - turnover.number) / turnover.number * 100;
      goalCrAvgBasketTurnoverIncrease.isResult = true;
      this.setObjContent('goalCrAvgBasketTurnoverIncrease', goalCrAvgBasketTurnoverIncrease, 0);


      //goalVisitorsCrAvgBasket

      //goalVisitorsCrAvgBasketVisitors
      goalVisitorsCrAvgBasketVisitors.number = goalVisitorsVisitors.number;
      this.setObj('goalVisitorsCrAvgBasketVisitors',  goalVisitorsCrAvgBasketVisitors.number, 0);

      //goalVisitorsCrAvgBasketAvgBasket
      goalVisitorsCrAvgBasketAvgBasket.number = goalAvgBasketAvgBasket.number;
      this.setObj('goalVisitorsCrAvgBasketAvgBasket',  goalVisitorsCrAvgBasketAvgBasket.number, 0);

      //goalVisitorsCrAvgBasketCr
      goalVisitorsCrAvgBasketCr.number = goalCrCr.number;
      this.setObj('goalVisitorsCrAvgBasketCr',  goalVisitorsCrAvgBasketCr.number, 0);

      //goalVisitorsCrAvgBasketOrders
      goalVisitorsCrAvgBasketOrders.number = Math.floor(goalVisitorsCrAvgBasketVisitors.number * goalVisitorsCrAvgBasketCr.number / 100);
      this.setObj('goalVisitorsCrAvgBasketOrders',  goalVisitorsCrAvgBasketOrders.number, 0);

      //goalVisitorsCrAvgBasketTurnover
      goalVisitorsCrAvgBasketTurnover.number = goalVisitorsCrAvgBasketOrders.number * goalVisitorsCrAvgBasketAvgBasket.number;
      this.setObj('goalVisitorsCrAvgBasketTurnover',  goalVisitorsCrAvgBasketTurnover.number, 0);

      //goalVisitorsCrAvgBasketTurnover
      if (goalVisitorsCrAvgBasketVisitors.number > 0) {
        goalVisitorsCrAvgBasketCustomerValue.number = goalVisitorsCrAvgBasketTurnover.number / goalVisitorsCrAvgBasketVisitors.number;
        this.setObj('goalVisitorsCrAvgBasketCustomerValue', goalVisitorsCrAvgBasketCustomerValue.number, 0);
      }

      //goalVisitorsCrAvgBasketTurnoverIncrease
      goalVisitorsCrAvgBasketTurnoverIncrease.number = (goalVisitorsCrAvgBasketTurnover.number - turnover.number) / turnover.number * 100;
      goalVisitorsCrAvgBasketTurnoverIncrease.isResult = true;
      this.setObjContent('goalVisitorsCrAvgBasketTurnoverIncrease', goalVisitorsCrAvgBasketTurnoverIncrease, 0);

    }
  }
}
</script>

<style scoped>

.main-th {
  font-size: 18px;
  font-weight:700;
}

.sub-tr {
  background-color: #F0F3F7;
}
.sub-tr th {
  font-size: 16px;
  font-weight:700;
  text-align:right;
  padding: 10px 0;
}

.sub-content-tr td {
  text-align: right;
  font-weight:700;
}

.sub-content-tr td:first-child {
  text-align: left;
  font-weight:300;
}

</style>